/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentEditorsScholarshipTypesQueryResponse,
  GetApiV1IndividualpaymentEditorsScholarshipTypesQueryParams,
  GetApiV1IndividualpaymentEditorsScholarshipTypes401,
  GetApiV1IndividualpaymentEditorsScholarshipTypes500,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsScholarshipTypes.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentEditorsScholarshipTypes } from "../../clients/individualPaymentEditorsController/getApiV1IndividualpaymentEditorsScholarshipTypes.ts";

export const getApiV1IndividualpaymentEditorsScholarshipTypesQueryKey = (
  params?: GetApiV1IndividualpaymentEditorsScholarshipTypesQueryParams,
) =>
  [
    { url: "/api/v1/individualpayment/editors/scholarship-types" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1IndividualpaymentEditorsScholarshipTypesQueryKey =
  ReturnType<typeof getApiV1IndividualpaymentEditorsScholarshipTypesQueryKey>;

export function getApiV1IndividualpaymentEditorsScholarshipTypesQueryOptions(
  params?: GetApiV1IndividualpaymentEditorsScholarshipTypesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentEditorsScholarshipTypesQueryKey(params);
  return queryOptions<
    GetApiV1IndividualpaymentEditorsScholarshipTypesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsScholarshipTypes401
      | GetApiV1IndividualpaymentEditorsScholarshipTypes500
    >,
    GetApiV1IndividualpaymentEditorsScholarshipTypesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentEditorsScholarshipTypes(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Empresa com igualdade exata (sem 'companyId' retorna apenas bolsas sem empresa). 'scholarshipTypeId' inclui bolsa inativa já vinculada ao plano. Migrado do legado ScholarshipType/GetDropDownList. **(Requer Authorization para autenticação)**
 * @summary Bolsas disponíveis por empresa (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/editors/scholarship-types}
 */
export function useGetApiV1IndividualpaymentEditorsScholarshipTypes<
  TData = GetApiV1IndividualpaymentEditorsScholarshipTypesQueryResponse,
  TQueryData = GetApiV1IndividualpaymentEditorsScholarshipTypesQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentEditorsScholarshipTypesQueryKey,
>(
  params?: GetApiV1IndividualpaymentEditorsScholarshipTypesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentEditorsScholarshipTypesQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentEditorsScholarshipTypes401
          | GetApiV1IndividualpaymentEditorsScholarshipTypes500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentEditorsScholarshipTypesQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentEditorsScholarshipTypesQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsScholarshipTypes401
      | GetApiV1IndividualpaymentEditorsScholarshipTypes500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
